export default __webpack_public_path__ + "static/media/Flag_of_Gabon.337f88ad.svg";